import store from '@/store/index.js'
import router from '@/router/index.js'
import { makeRequest } from '@/libs/RequestModule'
import { setLocalVar } from '@/libs/Util.js'
import { getEnv } from '@/libs/Environment.js'
import { log } from '@/libs/Logger.js'
import md5 from 'md5'
import moment from 'moment'

const doLogOut = function () {
    setLocalVar('SESSIONTOKEN', null)
    store.dispatch('setBaseInfo', {
        CDCLIENTE: '',
        CDFILIAL: '',
        NMFANTCLIE: ''
    })
    store.dispatch('setSelectedLoginOption', null)

    const password = store.getters.getLoginFormData[2].value === '%use@stored@pass%' ?
        store.getters.getRefreshToken :
        md5(`odhen${store.getters.getLoginFormData[2].value}7833`)

    store.dispatch('setAllUserData', {
        userName: store.getters.getLoginFormData[1].value,
        refreshToken: password,
        shouldRememberPassword: store.getters.getLoginFormData[3].value
    })
    router.push({ name: 'login' })
}

const activateUser = async function () {
    return await makeRequest('activateUser')
}

const blockUser = async function () {
    return await makeRequest('blockUser')
}

const getUseTerms = async function () {
    const response = await makeRequest('getUseTerms')
    return response
}

const _doLogin = async function (payload) {
    const selectedLoginOption = store.getters.getSelectedLoginOption

    if (getEnv().usa_instituicao_cliente_filial === 'S' && selectedLoginOption) {
        payload.client = selectedLoginOption.CDCLIENTE
        payload.filial = selectedLoginOption.CDFILIAL
    }

    payload.appVersion = process.env.VERSION
    const response = await makeRequest('login', payload)
    if (response.data && !response.data.token) {
        return { error: true, errMessage: response.message }
    }
    if (!(response?.data?.token === md5(`teknisa ${moment().format('DDMMYYYY')}`))) {
        response.errMessage = response?.data?.message || response?.message
        return response
    }
    await store.dispatch('setACCTERMOSUSOAPP', response?.data?.ACCTERMOSUSOAPP)
    await store.dispatch('setNMRESPCONS', response?.data?.NMRESPCONS)

    setLocalVar('SESSIONTOKEN', response?.data?.ACCESSTOKEN)
    const { data } = await getUseTerms()
    await store.dispatch('setUseTerm', data?.TERMOSUSOAPPTXT)
    return response
}

const doLogin = async function (refresh = false) {
    const user = store.getters.getLoginFormData[1].value
    const password = store.getters.getLoginFormData[2].value === '%use@stored@pass%' ?
        store.getters.getRefreshToken :
        md5(`odhen${store.getters.getLoginFormData[2].value}7833`)

    const rmbpassword = store.getters.getLoginFormData[3].value

    const atLoginPage = router.currentRoute.value.name === 'login'
    const loginControlsAvailability = store.getters.loginControlsEnabled === true
    const allFieldsFilled = !!user && !!password
    const baseInfo = store.getters.getBaseInfo

    if (atLoginPage && !refresh) {
        if (loginControlsAvailability) {
            if (!allFieldsFilled) {
                await store.dispatch('showModalInfo', { type: 'error', text: 'Todos os campos são obrigatórios', open: true })
                return false
            }
            await store.dispatch('setLoginControlsEnabled', !store.getters.loginControlsEnabled)

            const response = await _doLogin({
                username: user,
                password: password,
                client: baseInfo.CDCLIENTE,
                filial: baseInfo.CDFILIAL
            })

            await store.dispatch('setLoginControlsEnabled', !store.getters.loginControlsEnabled)

            if (response.error) {
                let message = response.errMessage || 'Não foi possível realizar o login'
                if (response.code && response.code === 'ERR_NETWORK') {
                    message = 'Sem conexão. Verifique a conexão com a internet e tente novamente.'
                }
                await store.dispatch('showModalInfo', { type: 'error', text: message, open: true })
                return false
            }

            if (!response.data.showSelectPopup) {
                await store.dispatch('setAllUserData', {
                    userName: user,
                    refreshToken: password,
                    shouldRememberPassword: rmbpassword
                })
            }

            return response
        }
    } else {
        const response = await _doLogin({
            username: store.getters.getUsername,
            password: store.getters.getRefreshToken,
            client: baseInfo.CDCLIENTE,
            filial: baseInfo.CDFILIAL
        })

        if (response.errMessage) {
            const message = response.errMessage || 'Não foi possível autenticar'
            await store.dispatch('showModalInfo', { type: 'error', text: message, open: true })
            doLogOut()
        }
        return response
    }
}

const getClients = async function () {
    const response = (await makeRequest('getClients'))?.data
    return response
}

const forgotPassword = async function (NMLOGINCONS, CDCLIENTE = null) {
    const raw = await makeRequest('forgotPassword', { NMLOGINCONS, CDCLIENTE: CDCLIENTE || '' })
    return raw?.data ?? raw
}

const updatePasswordAfterRecover = async function (CDCLIENTE, NMLOGINCONS, newPassword, CDCONSUMIDOR = null) {
    const response = (await makeRequest('updatePasswordAfterRecover', { CDCLIENTE, NMLOGINCONS, newPassword, CDCONSUMIDOR }))?.data
    return response
}

const getRetailGeneralParams = async () => {
    await makeRequest('getRetailGeneralParams', {})
        .then(response => {
            if (response?.sucesso && response?.data) {
                store.dispatch('setRetailGeneralParams', response.data)
                store.dispatch('setShowRegisterButton', response.data.HABCADASTRO === 'S')
            }
        })
        .catch(error => {
            store.dispatch('setShowRegisterButton', false)
            log({ type: 'error', message: `Erro em getRetailGeneralParams:\n${error.message}` })
        })
}

const getPermissions = async () => {
    await makeRequest('getPermissions', {})
        .then(response => {
            if (response.sucesso && response.data) {
                store.dispatch('setPermissions', response.data)
            }
        }).catch(error => {
            log({ type: 'error', message: `Erro em getPermissions:\n${error.message}` })
        })
}

export {
    doLogin,
    doLogOut,
    getClients,
    forgotPassword,
    updatePasswordAfterRecover,
    getRetailGeneralParams,
    activateUser,
    blockUser,
    getPermissions
}
